import React, { useContext, useRef, useState, useEffect, useLayoutEffect } from 'react';
import { CommsPanelCtx } from '../../contexts';
import EmailSingle from './Email';
import EmailSingle2 from './Email/v2';
import EmailSingle3 from './Email/v3';
import LeoPanel from './Leo';


const EmailSmsPanels = () => {
    const { panels, closePanel, toggleMinimized } = useContext( CommsPanelCtx );
    const [ orderedPanels, setOrderedPanels ] = useState( [] );
    const containerRef = useRef( null );
    const lastPanelRef = useRef( null );

    useLayoutEffect( () => {
        if ( lastPanelRef.current ) {
            // 'nearest' ensures minimal jump, 'end' aligns right edge
            lastPanelRef.current.scrollIntoView( {
                behavior: 'auto',
                block: 'nearest',
                inline: 'end',
            } );
        }
    }, [ panels.length ] );
    
    useEffect( () => {
        const list = [ ...panels ];
        setOrderedPanels( list.reverse() );
    }, [ panels ] );

    return (
        <div className="panels-wrapper" ref={containerRef}>
            <div className='panels-spacer' />
            {
                orderedPanels.map( ( panel, idx ) => {
                    const isMinimized = panel.minimized;
                    const isLast = idx === orderedPanels.length - 1;
                    
                    return ( 
                        <div 
                            key={panel.id} 
                            className={`email-sms-panel ${isMinimized ? 'minimized' : 'open'}`}
                        >
                            {
                                panel.panelType === 'email' ? (
                                    <EmailSingle2
                                        obj={panel.obj}
                                        objType={panel.objType}
                                        tmpl={panel.tmpl}
                                        open={true}
                                        onClose={ () => closePanel( panel.id ) }
                                        onMinimize={ () => toggleMinimized( panel.id ) } 
                                        ref={isLast ? lastPanelRef : null}
                                    />
                                ) : (
                                    null
                                )
                            }
                            {
                                panel.panelType === 'leo' ? (
                                    <LeoPanel 
                                        open={true}
                                        onClose={ () => closePanel( panel.id ) }
                                        onMinimize={ () => toggleMinimized( panel.id ) } 
                                        ref={isLast ? lastPanelRef : null}
                                    />
                                ) : (
                                    null
                                )
                            }
                        </div>
                    );
                } )
            }
        </div>
    );
};

export default EmailSmsPanels;